/**
 * Global identifiers for the different modules or pages in the application.
 * Used for contextual features like the Learning Videos (Tutorials).
 */
export enum ProductIds {
  ORDERS_GRID = 'ORDERS_GRID',
  ORGANIZATION_SETTINGS = 'ORGANIZATION_SETTINGS',
  ANALYTICS = 'ANALYTICS',
  ORDER = 'ORDER',
  DELIVERY = 'DELIVERY',
}

export const productIdsNameMap: Record<ProductIds, string> = {
  [ProductIds.ORDERS_GRID]: 'Pedidos',
  [ProductIds.ORGANIZATION_SETTINGS]: 'Organización',
  [ProductIds.ANALYTICS]: 'Analíticas',
  [ProductIds.ORDER]: 'Pedidos',
  [ProductIds.DELIVERY]: 'Entregas',
};
